"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _defaultTemplate = _interopRequireDefault(require("./defaultTemplate.js"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/svg/checkmark"));
var _cccisdVideo = require("cccisd-video");
var _style = _interopRequireDefault(require("./style.css"));
var _settings = require("./settings.js");
var _cccisdColorPicker = require("cccisd-color-picker");
var _color = _interopRequireDefault(require("color"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Player = function Player(props) {
  var field = props.field,
    settings = props.settings,
    accommodations = props.accommodations,
    showQuestionNumbers = props.showQuestionNumbers,
    startQuestionNumber = props.startQuestionNumber,
    isPrintMode = props.isPrintMode,
    setupManualActions = props.setupManualActions,
    registerAction = props.registerAction;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentItemId = _useState2[0],
    setCurrentItemId = _useState2[1];
  var visited = field.value && field.value.visited ? field.value.visited : [];
  var pageTitleColor = (0, _cccisdColorPicker.getColor)((0, _get2["default"])(props, 'playerTemplateProps.templateSettings.pageTitleColor') || '#337ab7');
  var darkenPageTitleColor = '#337ab7';
  try {
    darkenPageTitleColor = (0, _color["default"])(pageTitleColor).darken(0.1).hex();
  } catch (e) {
    // do nothing
  }
  if (isPrintMode) {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: settings.question
    }), settings.description && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].description
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: settings.description
    })), settings.items.map(function (item) {
      var itemType = settings.itemTypes["static"].find(function (type) {
        return type.id === item.id;
      });
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: item.id
      }, /*#__PURE__*/_react["default"].createElement("h3", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: item.label
      })), itemType && itemType.contentType === 'text' && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: itemType.text
      }));
    }));
  }
  var items = settings.items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      key: item.id,
      content: item.label,
      render: function render(_ref) {
        var html = _ref.html,
          playAudio = _ref.playAudio,
          getAction = _ref.getAction;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames2["default"])(_style["default"].item, _defineProperty(_defineProperty({}, _style["default"].visited, currentItemId !== item.id && visited.includes(item.id)), _style["default"].current, currentItemId === item.id)),
          onClick: function onClick() {
            if (item.id !== currentItemId) {
              setCurrentItemId(item.id);
              if (!visited.includes(item.id)) {
                field.onChange(_objectSpread(_objectSpread({}, field.value), {}, {
                  visited: [].concat(_toConsumableArray(visited), [item.id])
                }));
              }
              if (setupManualActions) {
                setupManualActions();
                var action = getAction();
                if (action) {
                  registerAction(1, action);
                }
              } else {
                playAudio();
              }
            }
          },
          style: currentItemId === item.id ? {
            backgroundColor: pageTitleColor,
            borderColor: darkenPageTitleColor
          } : {}
        }, html, visited.includes(item.id) && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].checkmark
        }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)));
      }
    });
  });
  var currentItemType = settings.itemTypes["static"].find(function (type) {
    return type.id === currentItemId;
  });
  var currentItemContent = currentItemType ? /*#__PURE__*/_react["default"].createElement("div", {
    key: currentItemId
  }, currentItemType.contentType === 'text' ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: currentItemType.text,
    registerAction: props.registerAction.bind(null, 5)
  }) : /*#__PURE__*/_react["default"].createElement(_cccisdVideo.Player, _extends({}, (0, _pick2["default"])(props, ['accommodations', 'setParameters', 'registerAction', 'template', 'templateExtraProps', 'playerTemplateProps', 'isPrintMode']), {
    field: {
      value: {},
      onChange: function onChange() {}
    },
    settings: currentItemType.video
  }))) : null;
  var elementStyle = (0, _get2["default"])(props, 'playerTemplateProps.playerTemplateSettings.elementStyle');
  var templateProps = _objectSpread({
    question: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: settings.question,
      registerAction: props.registerAction.bind(null, 1),
      setParameters: props.setParameters,
      accommodations: accommodations,
      prependWith: showQuestionNumbers && "".concat(startQuestionNumber, ". ")
    }), settings.description && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].description
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: settings.description
    }))),
    items: items,
    currentItemId: currentItemId,
    setCurrentItemId: setCurrentItemId,
    currentItemType: currentItemType,
    currentItemContent: currentItemContent,
    // Advanced props
    settings: settings,
    field: field,
    playerTemplateProps: props.playerTemplateProps,
    accommodations: accommodations,
    elementStyle: elementStyle,
    visited: visited
  }, props.templateExtraProps);
  var Template = props.template || _defaultTemplate["default"];
  return /*#__PURE__*/_react["default"].createElement(Template, templateProps);
};
Player.propTypes = {
  field: _propTypes["default"].object,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func
};
Player.defaultProps = {
  registerAction: function registerAction() {},
  setParameters: function setParameters() {}
};
var _default = exports["default"] = (0, _cccisdSurveyCommon.playerWrapper)({
  validate: _settings.validate
})(Player);